import { render, staticRenderFns } from "./EventoSales.vue?vue&type=template&id=3cdad544"
import script from "./EventoSales.vue?vue&type=script&setup=true&lang=js"
export * from "./EventoSales.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports